<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-attributes-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
            <h5>{{ (localizationKeyPrefix + '.Summary.Title') | abpLocalization }} <zn-pill [label]="displayValue(originalStandName())"></zn-pill></h5>
            <p>{{ (localizationKeyPrefix + '.Summary.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-summary-container">
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::Entity.ForestryBase.PropertyName' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.establishment) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::Entity.ForestryBase.ForestrySituation' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.forestSituation) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::Entity.Cycle' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.cycle) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::Entity.StandCycleRotation.PropertyType' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.propertyType) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::Entity.ForestryBase.LandContract' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.landContract) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'Geographic::StandDivision.StepSelectStandToDivide.Fields.ForestContract' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.forestContract) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'LanguageService::Stand.Spacing' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.spacing) }}</p>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ 'LanguageService::Stand.OwnPlantation' | abpLocalization }}</p>
          <p class="subtitle">{{ displayValue(originalSummary()?.ownPlantation) }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section stand-division-attributes-section stand-division-attributes-section--table">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="rows().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                <th>{{ 'LanguageService::Stand.StandType' | abpLocalization }}</th>
                <th>{{ 'LanguageService::Stand.NearbyPopulation' | abpLocalization }}</th>
                <th>{{ 'LanguageService::Stand.Rotation' | abpLocalization }}</th>
                <th>{{ 'Geographic::Entity.Plantation.PlantationDate' | abpLocalization }}</th>
                <th>{{ 'LanguageService::Stand.PlantingType' | abpLocalization }}</th>
                <th>{{ 'LanguageService::Stand.GeneticMaterial' | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.Season') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.Contractor') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.StandState') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Table.Columns.Actions') | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (rows().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="11">
                    {{ (localizationKeyPrefix + '.Table.Empty') | abpLocalization }}
                  </td>
                </tr>
              }

              @for (row of rows(); track row.id) {
                <tr [class.stand-division-attributes-row--configured]="!!row.configuration">
                  <td>{{ row.name }}</td>
                  <td>{{ row.configuration?.standTypeLabel ?? '' }}</td>
                  <td>{{ row.configuration?.nearbyPopulationLabel ?? '' }}</td>
                  <td>{{ row.configuration?.rotation ?? '' }}</td>
                  <td>{{ row.configuration?.plantingDate ?? '' }}</td>
                  <td>{{ row.configuration?.plantingTypeLabel ?? '' }}</td>
                  <td>{{ row.configuration?.geneticMaterialLabel ?? '' }}</td>
                  <td>{{ row.configuration?.seasonLabel ?? '' }}</td>
                  <td>{{ row.configuration?.contractorLabel ?? '' }}</td>
                  <td>{{ row.configuration?.standStateLabel ?? '' }}</td>
                  <td class="stand-division-attributes-actions">
                    <zn-button
                      [type]="actionType(row)"
                      size="small"
                      [label]="actionLabelKey(row) | abpLocalization"
                      (clicked)="openConfiguration(row)"
                    ></zn-button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
